import { render, staticRenderFns } from "./BcTemplates.vue?vue&type=template&id=6838c14a&scoped=true"
import script from "./BcTemplates.vue?vue&type=script&lang=js"
export * from "./BcTemplates.vue?vue&type=script&lang=js"
import style0 from "./BcTemplates.vue?vue&type=style&index=0&id=6838c14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6838c14a",
  null
  
)

export default component.exports